var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({attrs:{"loading":_vm.exporting,"disabled":_vm.disabled || _vm.exporting,"color":"success","elevation":"2"},on:{"click":_vm.exportarExcel}},'v-btn',_vm.$attrs,false),[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-microsoft-excel")]),_c('span',[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }